import { useEffect, useState } from "react";

import { absenceApi } from "../services";
import type { EmployeeAvailability } from "../types";

const DEBOUNCE = 250;

const PER_PAGE = 50;

export function useAvailableEmployees(
  from: string | null,
  to: string | null,
  search: string,
): { employees: EmployeeAvailability[]; loading: boolean } {
  const [employees, setEmployees] = useState<EmployeeAvailability[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!from || !to) {
      return;
    }

    const controller = new AbortController();

    const timeout = setTimeout(() => {
      setLoading(true);

      absenceApi
        .fetchAvailableEmployees(
          {
            from,
            to,
            search: search.trim() || undefined,
            page: 1,
            perPage: PER_PAGE,
          },
          { signal: controller.signal },
        )
        .then((page) => {
          setEmployees(page.items);
          setLoading(false);
        })
        .catch(() => {
          // Aborted or offline: the picker keeps whatever it already listed
        });
    }, DEBOUNCE);

    return () => {
      clearTimeout(timeout);
      controller.abort();
    };
  }, [from, to, search]);

  // Without a period there is nobody to be available, and reporting that as a
  // derived empty list keeps the effect from writing state on its way in.
  const enabled = Boolean(from && to);

  return { employees: enabled ? employees : [], loading: enabled && loading };
}
